// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__u0ny8","savePackageButton":"ClientWallet_savePackageButton__3ZWOG"};